// Tier2 Submit 2025 Rev 1 rejects one-character top-level domains (a@b.c) on contacts and state email fields.
export const EMAIL_PATTERN = '^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$';

/** Validate email syntax, not whether the mailbox exists. */
export function isValidEmail(value: string | null | undefined): boolean {
  return value != null && new RegExp(EMAIL_PATTERN).test(value.trim());
}
